import { createActionConst } from '../../../utils/action.utils';

const NODE_NAMESPACE = 'NODE';

export const STORE_NODE = createActionConst(NODE_NAMESPACE, 'STORE_NODE');
export const CLEAR_NODE = createActionConst(NODE_NAMESPACE, 'CLEAR_NODE');
